<template>
  <div id="create">
    <v-container fluid id="anpr-listing-view" class="px-2">
      <v-data-table
        :mobile-breakpoint="mobilebreakpoint"
        :headers="headersemail"
        :items="listingEmailData"
        :items-per-page="10"
        :search="searchemail"
        class="elevation-4 mt-2"
        :footer-props="{
          itemsPerPageOptions: [10, 20, 40, 80, -1],
          'items-per-page-text': 'rows/page',
        }"
        :loading="tableLoading"
        loading-text="Loading... Please wait"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-text-field
              v-model="searchemail"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
          </v-toolbar>
        </template>

        <template v-slot:item.description="{ item }">
          <span v-html="item.description"></span>
        </template>
        <template v-slot:item.hyperLink="{ item }">
          <a target="_blank" :href="item.hyperLink">
            Go To
          </a>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>
<style scoped>
.v-data-table {
  max-width: 100%;
}
</style>
<script>
import axios from "axios";
import { get } from "vuex-pathify";

import moment from "moment";
import { showSnackbar } from "../util/globalActions";
export default {
  name: "StudyMaterialView",

  data: () => ({
    tab: null,
    tableLoading: false,
    modal: false,
    fromDate: null,
    toDate: null,
    switchmobilebreakpoint: false,
    mobilebreakpoint: "200",
    expandedemail: [],
    expandedsms: [],
    singleExpand: true,
    searchemail: "",
    searchsms: "",
    listingEmailData: [],
    listingSMSData: [],
    message: "",
    snackbar: false,
    reqRules: [(v) => !!v || "Field is required"],
    professor_id: null,
    headersemail: [
      {
        value: "srNo",
        text: "Sr.No.",
        width: "100px",
      },
      {
        value: "name",
        text: "Name",
        width: "200px",
      },
      {
        value: "hyperLink",
        text: "HyperLink",
        width: "100px",
      },
      {
        text: "Description",
        value: "description",
        width: "520px",
      },
    ],
  }),
  created() {
    this.showData();
  },
  mounted() {},
  computed: {
    apiUrl: get("app/apiUrl"),
    userid: get("user/id"),
    menuid: get("user/menuid"),
    selecteduserid: get("app/selecteduserid"),
  },
  watch: {
    switchmobilebreakpoint: function(value) {
      if (value === true) this.mobilebreakpoint = "600";
      else this.mobilebreakpoint = "200";
    },
  },
  methods: {
    formatDate(value, dateFormat) {
      if (!value) return "Not Found";
      return moment(String(value)).format(dateFormat);
    },
    showData() {
      const self = this;
      self.selectedfromdate = self.fromDate;
      self.selectedtodate = self.toDate;

      self.tableLoading = true;

      axios({
        url: self.apiUrl + "api/Link/GetOTHLink",

        method: "GET",
        responseType: "json",
      })
        .then(function(res) {
          self.listingEmailData = res.data;
          self.tableLoading = false;
        })
        .catch(function(err) {
          self.tableLoading = false;
          self.message = err.status;

          showSnackbar({ message: "Data not found!" });
        });
    },
  },
};
</script>
